export const PAGE_HOME = 1;  //首页
export const PAGE_TEAM = 2;  //团队
// export const PAGE_COMPANY = 3; //公司
export const PAGE_SERVICES = 3;  //服务
export const PAGE_CASE_DETAIL = 5;  //案例详情
export const PAGE_WATERFALL = 6;  //瀑布流
export const PAGE_USER_EXPERIENCE = 7;  //用户体验
export const PAGE_USER_EXPERIENCE_DETAIL = 8;  //用户体验详情
export const USER_EXPERIENCE = 4;  //用户体验
export const USER_EXPERIENCE_DETAIL = 2;  //用户体验详情
